export default "__VITE_ASSET__zZLuKYX1__"